exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-address-field--component-wrapper[data-v-e352c140] {\n  /*display: flex;*/\n  /*justify-content: space-between;*/\n  /*align-items: center;*/\n}\n", ""]);

// exports
